import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast-container',
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.css'],
  standalone: true,
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) { }

  isTemplate(value: any): value is TemplateRef<any> {
    return value instanceof TemplateRef;
  }
}